
export const BILL_STATUS = {
  10: '待对账',
  20: '待付款',
  30: '待收款',
  40: '已结算',
  50: '已取消'
};

export const BILL_STATUS_DESCRIBE = {
  10: '待对账',
  20: '待付款',
  30: '待收款',
  40: '已结算',
  50: '已完成'
};